export function getDifference(
  a: number,
  b: number
): number {
  return Math.abs(a - b)
}